import Immutable from 'immutable';
import normalizeSearchTerm from '../utils/normalizeSearchTerm';
import {
    LOADING_AUTO_COMPLETE,
    LOAD_AUTO_COMPLETE_SUCCESS,
    LOAD_AUTO_COMPLETE_ERROR,
    UPDATE_ACTIVE_QUERY,
} from '../actions/header/autocomplete';

const AUTO_COMPLETE = 'autocomplete';
const STATUS = 'status';
const CONTENT = 'content';
const SHOW_RESULTS = 'showResult';
const ACTIVE_QUERY = 'activeQuery';

const NO_TEXT = '';
const MAX_TITLE_ITEMS = 5;
const MAX_CLUSTER_ITEMS = 2;
const EMPTY_RESULT = [];
const MIN_CHARS_BEFORE_WILDCARD_MATCH = 3;

let initialState = Immutable.fromJS({
    activeQuery: {
        showResult: false,
        results: EMPTY_RESULT,
        searchTerm: NO_TEXT,
    },
    status: {},
    content: {},
});

export const autocompleteContentSelector = (state) => state.getIn([AUTO_COMPLETE, CONTENT]);
export const autocompleteStatusSelector = (state) => state.getIn([AUTO_COMPLETE, STATUS]);
export const autocompleteActiveQuerySelector = (state) => state.getIn([AUTO_COMPLETE, ACTIVE_QUERY]);
export const autocompleteIsVisibleSelector = (state) =>
    state.getIn([AUTO_COMPLETE, ACTIVE_QUERY, SHOW_RESULTS]);

function sortList(list) {
    list.sort((a, b) => {
        if (a.weight === b.weight) {
            return b.popularity - a.popularity;
        }

        return a.weight - b.weight;
    });

    return list;
}

function updateActiveQuery(state, payload) {
    let searchTerm = payload.query || '';
    let query = state.get(ACTIVE_QUERY, Immutable.Map());
    let content = state.get(CONTENT, []);

    let resultList = getAutoCompleteResult(content, searchTerm);
    let totalHits =
        resultList.get(0).get('size') + resultList.get(1).get('size') + resultList.get(2).get('size');

    let newResults = query.merge({
        results: resultList,
        searchTerm: searchTerm,
        totalHits: totalHits,
    });

    return newResults;
}

export function lookup(searchFor, searchIn) {
    const weight = searchIn.indexOf(searchFor);

    if (weight > -1) {
        if (weight === 0) {
            // Found a match in the beginning of the string = yay!

            return weight;
        } else if (searchFor.length > MIN_CHARS_BEFORE_WILDCARD_MATCH) {
            // MIN_CHARS... = Minimum number of characters required for a wildcard search
            // Found a match somewhere else in the string

            return weight;
        }

        // Look for a match in the beginning of a word within the string, no minimum number of characters are required

        const wordMatcher = new RegExp(' ' + searchFor, 'g');

        if (searchIn.match(wordMatcher)) {
            return weight;
        }
    }

    // No match :(
    return -1;
}

function getAutoCompleteResult(autoCompleteContent, searchTerm, removeWhiteSpace = false) {
    const normalizedSearchTerm = normalizeSearchTerm(searchTerm);
    const normalizedSearchTermWithoutWhitespace = normalizeSearchTerm(searchTerm, true);

    let clusters = [];
    let titles = [];
    let accessibility = [];

    if (normalizedSearchTerm) {
        autoCompleteContent.forEach((obj) => {
            let weight = lookup(normalizedSearchTerm, normalizeSearchTerm(obj.title));

            // If there was no match, test without whitespace
            if (weight === -1) {
                weight = lookup(normalizedSearchTermWithoutWhitespace, normalizeSearchTerm(obj.title, true));
            }

            if (weight > -1) {
                obj.weight = weight;

                if (obj.isGenre) {
                    clusters.push(obj);
                } else if (obj.isAccessibility) {
                    accessibility.push(obj);
                } else {
                    titles.push(obj);
                }
            }
        });

        clusters = sortList(clusters);
        titles = sortList(titles);
        accessibility = sortList(accessibility);
        //clusters
        if (clusters.length > MAX_CLUSTER_ITEMS) {
            clusters.splice(MAX_CLUSTER_ITEMS, Number.MAX_VALUE);
        }

        //titles
        if (titles.length > MAX_TITLE_ITEMS) {
            titles.splice(MAX_TITLE_ITEMS, Number.MAX_VALUE);
        }
    }

    return Immutable.fromJS([
        {
            title: 'Tillgänglighet',
            results: accessibility,
            size: accessibility.length,
        },
        {
            title: 'Genrer',
            results: clusters,
            size: clusters.length,
        },
        {
            title: 'Program',
            results: titles,
            size: titles.length,
        },
    ]);
}

export default function autocomplete(state = initialState, action) {
    switch (action.type) {
        case LOADING_AUTO_COMPLETE:
            return state.set(STATUS, action.payload);
        case LOAD_AUTO_COMPLETE_SUCCESS: {
            return state.set(STATUS, action.payload.status).set(CONTENT, action.payload.content);
        }
        case LOAD_AUTO_COMPLETE_ERROR:
            return state.set(STATUS, action.payload);
        case UPDATE_ACTIVE_QUERY:
            return state.set(ACTIVE_QUERY, updateActiveQuery(state, action.payload));

        default:
            return state;
    }
}
